export default __webpack_public_path__ + "static/media/houten jaloezieën.bae06a64.jpg";